import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: '页面不存在 - 琉璃神社',
    description: '你访问的页面不存在或已被移动，返回琉璃神社首页继续浏览动漫资讯、作品档案与文化专题。',
    keywords: '琉璃神社,页面不存在,404',
  });

  return (
    <SiteLayout>
      <div className="shell py-16 md:py-24">
        <div className="mx-auto max-w-2xl rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-14 text-center">
          <p className="font-label text-6xl md:text-8xl text-primary-200 tracking-widest">404</p>
          <h1 className="mt-4 text-xl md:text-2xl font-semibold">这个页面不见了</h1>
          <p className="mt-3 text-sm text-secondary-600 leading-7">
            你访问的地址可能是旧的链接，或者内容已经调整。可以回到首页，或从下面的入口继续浏览。
          </p>
          <p className="mt-2 text-[11px] text-secondary-400 font-label break-all">{location.pathname}</p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              返回首页
              <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
            <Link
              to="/category/news"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览动漫资讯
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}